export default __webpack_public_path__ + "static/media/search.75119bfd.svg";